import { useQuery } from '@tanstack/react-query';
import { reconClient } from '../../../utils/axios';

// GET /api/v1/filters — distinct supplier TINs (ERP + Marmin union).
export const fetchFilterValues = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await reconClient.get('/filters', { params, skipErrorSnackbar: true });
  return data;
};

export const useGetFiltersHandler = ({ ledger, enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['recon-filters', { ledger }],
    queryFn: fetchFilterValues,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
  });

  return { tins: data?.tins ?? [], isLoading };
};
